import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

import FormStep1 from './components/FormStep1.vue';
import FormStep2 from './components/FormStep2.vue';
import FormStep3 from './components/FormStep3.vue';
import FormStep4 from './components/FormStep4.vue';

export default {
  name: 'RegistrationPage',
  components: { FormStep1, FormStep2, FormStep3, FormStep4, VueSlickCarousel },
  props: ['invite_code'],
  data() {
    return {
      step: 1,
      loading: false,
      carouselSettings: {
        dots: true,
        arrows: false,
        dotsClass: 'slick-dots custom-dot-class',
        edgeFriction: 0.35,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
      },
      form: {
        phone: '',
        phone_mobile: '',
        checkedPers: false,
        token: '',
        first_name: '',
        last_name: '',
        middle_name: '',
        email: '',
        password: '',
        passwordConfirm: '',
        socialLink1: '',
        socialLink2: '',
        birthday_on_local: null,
        city_id: null,
        avatar: null,
        type_id: null,
        inn: '',
        companyName: '',
        companySite: '',
        invite_code: '',
      },
    };
  },
  computed: {
    type() {
      if (this.$store.state.settings.registration === 'unregistered_by_phone') {
        return 'sms_noprofile_or_unregistered';
      }
      if (this.$store.state.settings.registration === 'existing_by_phone') {
        return 'sms_profile_unregistered';
      }
      if (this.$store.state.settings.registration === 'free_by_phone') {
        return 'sms_noprofile';
      }
      return null;
    },
  },
  methods: {
    SubmitForm1(e) {
      this.form.phone = e.login;
      this.form.phone_mobile = e.login;
      this.form.checkedPers = e.checkedPers;
      this.form.invite_code = e.invite_code;
      this.SendCode().then((res) => {
        if (res) {
          this.step = 2;
        }
      });
    },
    /** Отправка проверочного СМС кода */
    SendCode() {
      const app = this;
      app.loading = true;
      return app.$store.getters.axl.post('api/token/get-sms', { type: app.type, phone: this.form.phone_mobile })
        .then(() => true)
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        })
        .finally(() => { app.loading = false; });
    },
    SubmitForm2(token) {
      this.form.token = token;
      this.step = 3;
    },
    SubmitForm3(data) {
      this.form = { ...this.form, ...data };
      this.step = 4;
    },
    SubmitForm4(data) {
      const app = this;
      this.form = { ...this.form, ...data };

      const payload = {
        ...this.form,
        social_link: this.form.socialLink1,
        social_link_additional: this.form.socialLink2,
        url: data.companySite,
      };
      app.$store.getters.axl.post('profiles/api/register', payload)
        .then((response) => {
          app.$store.commit('SetLogged', response.data);
          app.$store.dispatch('ShowInfo', 'Добро пожаловать в программу!');
          app.$router.push('/notConfirmed');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    goBack() {
      this.step -= 1;
    },
  },
  mounted() {
    if (this.$store.state.settings.extranet === true) {
      this.$router.push('/');
    }
    this.$store.dispatch('GetSettings');
  },
};
